import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from '@fairstone/ui/core/components';
import { t } from '@fairstone/ui/core/providers/Intl/locales/translate';
import PropTypes from 'prop-types';

import { ReactComponent as BarCode } from 'assets/images/digitalCard/barcode-button.svg';
import { ReactComponent as SmallFairstoneLogo } from 'assets/images/digitalCard/logo_fairstone_bi_white.svg';
import { formatAccountNumber } from 'utils/Formatter';

const DigitalCard = (props) => {
    const { formatMessage } = useIntl();
    const {
        accountNumber,
        isActive,
        merchantCardBackgroundColor,
        merchantCardBackgroundImage,
        merchantCardLogo,
        merchantCardLogoRightPosition,
        merchantCardLogoTopPosition,
        merchantLogoWidthPercentage,
        merchantName,
        ownerName,
        showDisclaimer,
        showFairstoneLogo,
    } = props;

    const { default: merchantCardLogoURL } = merchantCardLogo;
    const formattedAccountNumber = formatAccountNumber(accountNumber);

    const handleBarcodeClick = () => props.onBarcodeClick();

    return (
        <div className="digital-card">
            <p className="merchant-name" id="merchant-name" tabIndex={isActive ? '0' : '-1'}>
                {merchantName}
                <span className="visually-hidden">&nbsp;digital card</span>
            </p>
            <div
                className="card"
                id="card"
                style={{
                    backgroundColor: merchantCardBackgroundColor,
                    backgroundImage: merchantCardBackgroundImage,
                }}
            >
                <div
                    className="merchant-logo"
                    style={{
                        right: merchantCardLogoRightPosition,
                        top: merchantCardLogoTopPosition,
                        width: merchantLogoWidthPercentage,
                    }}
                >
                    <img alt="" id="merchant-logo" role="presentation" src={merchantCardLogoURL} />
                </div>
                <p className="account-number" id="account-number" tabIndex={isActive ? '0' : '-1'}>
                    {formattedAccountNumber}
                </p>
                <p className="customer-name" id="customer-name" tabIndex={isActive ? '0' : '-1'}>
                    {ownerName}
                </p>
                <div className="small-fs-logo" role="presentation">
                    {showFairstoneLogo && <SmallFairstoneLogo />}
                </div>
                <Button
                    appearance="text"
                    aria-label={formatMessage({ id: 'digital.card.showCode' })}
                    className="display-barcode-section"
                    onClick={handleBarcodeClick}
                    size="small"
                    tabIndex={isActive ? 0 : -1}
                >
                    <BarCode />
                    <p className="link" id="page-accountspage-cta-displayBarCode">
                        {t('digital.card.showCode')}
                    </p>
                </Button>
            </div>

            <div className={`card-disclaimer-${showDisclaimer ? 'show' : 'hide'}`}>
                {showDisclaimer && (
                    <p tabIndex={isActive ? '0' : '-1'}>
                        <FormattedMessage id="digital.card.disclaimer" />
                    </p>
                )}
            </div>
        </div>
    );
};

DigitalCard.propTypes = {
    accountNumber: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    merchantCardBackgroundColor: PropTypes.string,
    merchantCardBackgroundImage: PropTypes.string,
    merchantCardLogo: PropTypes.object.isRequired,
    merchantCardLogoRightPosition: PropTypes.string,
    merchantCardLogoTopPosition: PropTypes.string,
    merchantName: PropTypes.string.isRequired,
    merchantNumber: PropTypes.number.isRequired,
    onBarcodeClick: PropTypes.func.isRequired,
    ownerName: PropTypes.string.isRequired,
    showDisclaimer: PropTypes.bool.isRequired,
    showFairstoneLogo: PropTypes.bool.isRequired,
};

export default DigitalCard;
